"use client";

import { CSSProperties, FunctionComponent, ReactElement, ReactNode } from "react";
import { TailwindColors } from "../types/general";
import { Wrapper } from "./toast.styles";
import { Alert } from "../alert/alert";

export interface ToastProps {
    /**
     * Type of the toast.
     */
    type?: "error" | "warning" | "info" | "success";

    /**
     * Position of the toast.
     */
    position?: "top" | "bottom";

    /**
     * A callback function which will be fired on close the toast.
     */
    onClose: () => void;

    /**
     * Color of the toast.
     */
    color?: keyof TailwindColors | undefined;

    /**
     * Colorize only icon.
     */
    colorizeOnlyIcon?: boolean;

    /**
     * Whether the toast is visible or not.
     */
    visible?: boolean;

    /**
     * Icon of the toast.
     */
    icon?: ReactNode;

    /**
     * Message of the toast.
     */
    message: ReactElement | string;

    /**
     * Border radius of the toast.
     */
    rounded?: "md" | "lg";

    /**
     * Style of the toast.
     */
    style?: CSSProperties;

    /**
     * Class name of the alert.
     */
    className?: string;
}

export const Toast: FunctionComponent<ToastProps> = ({
    position,
    visible,
    type,
    color,
    icon,
    message,
    style,
    rounded,
    onClose,
    className,
    colorizeOnlyIcon,
}) => {
    return (
        <Wrapper position={position} visible={visible} rounded={rounded} className={className} style={style}>
            <Alert
                color={color}
                colorizeOnlyIcon={colorizeOnlyIcon}
                rounded={rounded}
                type={type}
                icon={icon}
                shadow={true}
                message={message}
                onClose={onClose}
            />
        </Wrapper>
    );
};
